<template>
<div>
  <b-navbar type="dark" variant="success" class="navbar-top border-bottom p-2">
    <b-navbar-nav v-if="!userNeedsOnboard && isEmailVerified && !loadError">
      <account-project-navbar-item class="ml-2"></account-project-navbar-item>
    </b-navbar-nav>
    <b-navbar-brand v-else class="m-2">
      <img src="../../assets/img/brand/white-logo.png" height="59" width="268" class="navbar-brand-img" alt="Imagine Products Logo"/>
    </b-navbar-brand>

    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <b-nav-item href="#" class="toggleView">
        <div class="mode-toggle" @click="modeToggle" :class="darkDark">
            <div class="toggle">
                <div id="dark-mode" type="checkbox"></div>
            </div>
        </div>
      </b-nav-item>
      <div class="nav-item">
        <user-notifications-dropdown></user-notifications-dropdown>
      </div>

      <b-nav-item href="#">
        <profile-navbar-item v-if="$auth.isAuthenticated"></profile-navbar-item>
      </b-nav-item>
    </b-navbar-nav>
  </b-navbar>

  <b-navbar v-if="!userNeedsOnboard" type="dark" variant="success" class="navbar-top border-bottom p-2">
    <b-navbar-nav>
      <b-nav-item>
        <route-bread-crumb></route-bread-crumb>
      </b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav>
      <b-nav-item href="#">
        <manifest-cart-quick-view></manifest-cart-quick-view>
      </b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav>
      <b-nav-item href="#">
        <entity-download-dashboard></entity-download-dashboard>
      </b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BNavbar } from 'bootstrap-vue';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb.vue';
import AccountProjectNavbarItem from '#/ui/Components/AccountProjectNavbarItem.vue';
import ProfileNavbarItem from '#/ui/Components/ProfileNavbarItem.vue';
import UserNotificationsDropdown from '#/ui/Components/User/UserNotificationsDropdown.vue';
import ManifestCartQuickView from '#/ui/Components/Manifest/ManifestCartQuickView.vue';
import EntityDownloadDashboard from "../Components/Entities/EntityDownloadDashboard";

export default {
  components: {
    EntityDownloadDashboard,
    ManifestCartQuickView,
    UserNotificationsDropdown,
    AccountProjectNavbarItem,
    ProfileNavbarItem,
    RouteBreadCrumb,
    BNavbar,
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description:
        'Look of the dashboard navbar. Default (Green) or light (gray)',
    },
  },
  computed: {
    ...mapGetters({
      loadError: 'loadError',
    }),
    ...mapGetters('user', ['userNeedsOnboard', 'isEmailVerified']),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    darkDark() {
      return this.darkMode && 'darkmode-toggled';
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      darkMode: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    modeToggle() {
      let darkMode = window.localStorage.getItem('darkMode');
      if (darkMode === 'false') {
        darkMode = 'true';
      } else {
        darkMode = 'false';
      }

      window.localStorage.setItem('darkMode', darkMode);
      if (darkMode === 'true') {
        document.querySelector('body').classList.add('dark-mode');
      } else {
        document.querySelector('body').classList.remove('dark-mode');
      }

      return this.$store.dispatch('setDarkMode', darkMode).then((response) => {
        console.log('Changed darkMode state ', response);
      }).catch((error) => {
        console.log('Change darkMode state error', error.message);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/_breakpoints.scss";

.navbar-top {
  @include media-breakpoint-up(sm) {
    .navbar-brand {
      display: inline;
    }
  }
}

.placeme{
  display: block;
  position: absolute;
  right: 30px;
  top: 10px;
}
.placeme1 {
  display: block;
  position: absolute;
  right: 60px;
  top: 10px;
}

// _mode-toggle.scss
.mode-toggle {
    position: relative;
    //margin: auto .5rem .5rem auto;
    padding: 0;
    width: 44px;
    height: 24px;
    min-width: 36px;
    min-height: 20px;
    background-color: #4c4c4e;
    border: 0;
    border-radius: 24px;
    outline: 0;
    overflow: hidden;
    cursor: pointer;
    z-index: 2;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-touch-callout: none;
    appearance: none;
    transition: background-color .5s ease;

    .toggle {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 3px solid transparent;
        box-shadow: inset 0 0 0 2px #a5abba;
        overflow: hidden;
        transition: transform .5s ease;

        #dark-mode {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 50%;

            &:before {
                content: '';
                position: relative;
                width: 100%;
                height: 100%;
                left: 50%;
                float: left;
                background-color: #a5abba;
                transition: border-radius .5s ease, width .5s ease, height .5s ease, left .5s ease, transform .5s ease;
            }
        }
    }
}

body.dark-mode {
    .mode-toggle {
        .toggle {
            transform: translateX(19px);

            #dark-mode {
                &:before {
                    border-radius: 50%;
                    width: 150%;
                    height: 85%;
                    left: 40%;
                    transform: translate(-10%, -40%), rotate(-35deg);
                }
            }
        }
    }
}
</style>
